import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

type StyleEntry =
  | SystemStyleObject<Theme>
  | ((theme: Theme) => SystemStyleObject<Theme>);

export const styles = {
  logoContainer2: {
    position: 'absolute',
    top: 12,
    right: 12,
    zIndex: -1,
    '& img': {
      height: '60px',
      width: '150px',
      objectFit: 'contain',
      aspectRatio: '1/1',
    },
  },
} satisfies Record<string, StyleEntry>;
